// Opening-anniversary helpers shared by the signals "Anniversaires" folder
// and the establishment detail page.

export interface UpcomingAnniversary {
    years: number;      // which anniversary is celebrated (e.g. 5)
    date: Date;         // the day of the celebration
    daysUntil: number;  // 0 = today
}

// Returns the establishment's next opening anniversary when it falls today or
// within the next `windowDays` days, null otherwise.
export function getUpcomingAnniversary(
    openingDate?: string | Date | null,
    windowDays = 7
): UpcomingAnniversary | null {
    if (!openingDate) return null;
    const opening = new Date(openingDate);
    if (isNaN(opening.getTime())) return null;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const anniversary = new Date(opening);
    anniversary.setHours(0, 0, 0, 0);
    anniversary.setFullYear(today.getFullYear());
    if (anniversary.getTime() < today.getTime()) {
        anniversary.setFullYear(today.getFullYear() + 1);
    }

    const years = anniversary.getFullYear() - opening.getFullYear();
    if (years < 1) return null; // opened this year, or a future opening

    const daysUntil = Math.round((anniversary.getTime() - today.getTime()) / 86400000);
    if (daysUntil > windowDays) return null;

    return { years, date: anniversary, daysUntil };
}

export function formatAnniversaryDelay(daysUntil: number): string {
    if (daysUntil === 0) return "aujourd'hui";
    if (daysUntil === 1) return "demain";
    return `dans ${daysUntil} jours`;
}
